import AdminLogin from "@/components/AdminLogin/AdminLogin";

const HomePage = () => {

    return (
        <div className="content">
            <h1>
                Home
            </h1>
            <AdminLogin />
        </div>
    )
}

export default HomePage;